<template>
  <div v-if="url" class="h-full relative product-search-teaser">
    <div class="space-y-20 lg:space-y-40 block size-full">
      <DrupalLink :to="url" class="block group h-full">
        <media-image v-if="image" v-bind="image" style-name="teaser_third" />
        <div class="absolute inset-0 gradient-background" />
        <div
          class="product-search-teaser-description is-4"
          v-html="description"
        />
        <div class="product-search-teaser-button">
          <button class="btn is-primary">
            {{ link?.title }}
          </button>
        </div>
      </DrupalLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#build/graphql-operations'

const props = defineProps<{
  title?: string
  description?: string
  link?: {
    title?: string
    uri?: {
      path?: string
    }
  }
  image?: MediaImageFragment
}>()

const url = computed(() => props.link?.uri?.path)
</script>

<style lang="postcss">
.product-search-teaser .gradient-background {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4), transparent 50%);
}
.product-search-teaser img {
  @apply w-full h-full object-cover;
}
.product-search-teaser-description {
  @apply absolute z-10 text-white md:text-sm lg:text-lg xl:text-2xl flex justify-center;
  @apply left-20 right-20 top-20;
}
.product-search-teaser-button {
  @apply absolute bottom-20 z-10 left-20 right-20;
  > button {
    @apply md:text-xs lg:text-sm;
  }
}
</style>
